var _style, _defs, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimulationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61.5 48",
    style: {
      enableBackground: "new 0 0 61.5 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000158014324345019520180000004631034300693793193_);}\n\t.st1{fill:#5C3B6B;}\n\t.st2{fill:#00A472;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#604674;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#00A472;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 61.5,
    height: 48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039136239358029472170000014309336279825016978_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5555",
    style: {
      clipPath: "url(#SVGID_00000039136239358029472170000014309336279825016978_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22544",
    className: "st1",
    d: "M9.1,48c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2 C11.3,47,10.3,48,9.1,48 M9.1,44.4c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4C10.5,45.1,9.9,44.4,9.1,44.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22545",
    className: "st1",
    d: "M16.7,48c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2 C18.9,47,17.9,48,16.7,48 M16.7,44.4c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4C18.1,45.1,17.5,44.4,16.7,44.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22546",
    className: "st1",
    d: "M24.3,48c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2c0,0,0,0,0,0 C26.5,47,25.6,48,24.3,48 M24.3,44.4c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4l0,0C25.7,45.1,25.1,44.4,24.3,44.4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4804",
    x: 10.9,
    y: 45.4,
    className: "st1",
    width: 4.1,
    height: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4805",
    x: 18.5,
    y: 45.4,
    className: "st1",
    width: 4.1,
    height: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22547",
    className: "st2",
    d: "M17.5,45.8c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8 C17.2,45,17.5,45.4,17.5,45.8L17.5,45.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22548",
    className: "st1",
    d: "M52.7,40.2H5.4c-3,0-5.4-2.4-5.4-5.4v-7.4c0-3,2.4-5.4,5.4-5.4h47.3c3,0,5.4,2.4,5.4,5.4 v7.4C58.1,37.8,55.7,40.2,52.7,40.2 M5.4,22.9c-2.5,0-4.4,2-4.4,4.4v7.4c0,2.5,2,4.4,4.4,4.4h47.3c2.5,0,4.4-2,4.4-4.4v-7.4 c0-2.5-2-4.4-4.4-4.4L5.4,22.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22549",
    className: "st2",
    d: "M49.1,33.2H9c-1.1,0-2.1-0.9-2.1-2.1l0,0V5C7,3.9,7.9,3,9,3c0,0,0,0,0,0h40 c1.1,0,2.1,0.9,2.1,2.1c0,0,0,0,0,0v26.2C51.1,32.3,50.2,33.3,49.1,33.2L49.1,33.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22550",
    className: "st2",
    d: "M52.8,39.7c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3l0,0 C54.8,44,52.8,42.1,52.8,39.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22551",
    className: "st3",
    d: "M57.1,41.8c-0.2,0-0.4-0.2-0.4-0.4V38c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4c0,0,0,0,0,0 v3.3C57.6,41.6,57.4,41.8,57.1,41.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22552",
    className: "st3",
    d: "M58.8,40.1h-3.3c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h3.3c0.2,0,0.4,0.2,0.4,0.4 C59.2,39.9,59,40.1,58.8,40.1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22553",
    className: "st4",
    d: "M21.3,21.3H5.1c-0.9,0-1.7-0.7-1.7-1.7v-18C3.4,0.7,4.2,0,5.1,0c0,0,0,0,0,0h16.2 c0.9,0,1.7,0.7,1.7,1.7v18C22.9,20.5,22.2,21.3,21.3,21.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22554",
    className: "st3",
    d: "M46.9,12.8H26.5c-0.2,0-0.3-0.1-0.3-0.3v-6c0-0.2,0.1-0.3,0.3-0.3h20.5 c0.2,0,0.3,0.1,0.3,0.3v6C47.3,12.7,47.1,12.9,46.9,12.8 M26.8,12.2h19.9V6.8H26.8V12.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22555",
    className: "st3",
    d: "M46.9,30H26.5c-0.2,0-0.3-0.1-0.3-0.3v-6c0-0.2,0.1-0.3,0.3-0.3h20.5 c0.2,0,0.3,0.1,0.3,0.3v6C47.3,29.9,47.1,30,46.9,30 M26.8,29.4h19.9V24H26.8V29.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22556",
    className: "st3",
    d: "M23.7,30H11.1c-0.2,0-0.3-0.1-0.3-0.3v-6c0-0.2,0.1-0.3,0.3-0.3h12.6 c0.2,0,0.3,0.1,0.3,0.3v6C24,29.9,23.8,30,23.7,30 M11.4,29.4h12V24h-12V29.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22557",
    className: "st3",
    d: "M35.3,21.6h-8.8c-0.2,0-0.3-0.1-0.3-0.3v-6c0-0.2,0.1-0.3,0.3-0.3h8.8 c0.2,0,0.3,0.1,0.3,0.3v6C35.6,21.4,35.5,21.6,35.3,21.6 M26.8,21H35v-5.4h-8.2V21z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22558",
    className: "st3",
    d: "M46.9,21.6h-8.8c-0.2,0-0.3-0.1-0.3-0.3v-6c0-0.2,0.1-0.3,0.3-0.3h8.8 c0.2,0,0.3,0.1,0.3,0.3v6C47.3,21.4,47.1,21.6,46.9,21.6 M38.4,21h8.2v-5.4h-8.2V21z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22559",
    className: "st3",
    d: "M44.1,9.8H29.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h14.7c0.2,0,0.3,0.1,0.3,0.3 C44.4,9.7,44.3,9.8,44.1,9.8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22560",
    className: "st3",
    d: "M44.1,27H29.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h14.7c0.2,0,0.3,0.1,0.3,0.3 C44.4,26.9,44.3,27,44.1,27"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22561",
    className: "st3",
    d: "M21.1,27h-7.4c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0,0h7.4 c0.2,0,0.3,0.1,0.3,0.3C21.4,26.9,21.2,27,21.1,27C21.1,27,21.1,27,21.1,27"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22562",
    className: "st3",
    d: "M32.7,18.6h-3.6c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h3.6c0.2,0,0.3,0.1,0.3,0.3 C33,18.4,32.8,18.6,32.7,18.6L32.7,18.6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22563",
    className: "st3",
    d: "M44.3,18.6h-3.6c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h3.6c0.2,0,0.3,0.1,0.3,0.3 C44.6,18.4,44.5,18.6,44.3,18.6L44.3,18.6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22564",
    className: "st2",
    d: "M19,6.7c0.2-0.7,0.2-1.3,0.1-2c-0.5-1.6-4.4-3.9-8.2-1.3C8,5.5,9.6,7.9,7.7,9 c-2,1.1-2.8,3.7-1.7,5.8l7.9-0.1L19,6.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22565",
    className: "st3",
    d: "M15.8,19.2L15.8,19.2c-1.3,0.1-2.5-0.6-2.5-1.7l-0.2-8c-0.1-1.3,0.9-2.5,2.2-2.6 c1.3-0.1,2.5,0.9,2.6,2.2c0,0.1,0,0.1,0,0.2l0.3,7.2C18.1,17.9,17.1,19.1,15.8,19.2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22566",
    className: "st3",
    d: "M17.7,14.5L17.7,14.5c-2,0.5-4.1-0.7-4.7-2.7l-0.6-2.4c-0.5-2,0.8-4.1,2.8-4.6 c1.9-0.5,3.9,0.7,4.5,2.6l0.6,2.4C20.9,11.9,19.7,14,17.7,14.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22567",
    className: "st3",
    d: "M15,10.8c0,0.8-0.6,1.5-1.4,1.5c-0.8,0-1.5-0.6-1.5-1.4c0-0.8,0.6-1.5,1.4-1.5 C14.3,9.4,14.9,10,15,10.8C15,10.8,15,10.8,15,10.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22569",
    className: "st2",
    d: "M13.7,11.1c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0-0.2-0.1-0.3-0.3-0.3 c-0.1,0-0.2,0-0.2,0.1c0,0-0.1,0.1-0.2,0s-0.1-0.1,0-0.2c0.2-0.2,0.6-0.2,0.8,0c0.1,0.1,0.2,0.3,0.2,0.4 C13.8,11,13.8,11.1,13.7,11.1C13.7,11.1,13.7,11.1,13.7,11.1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22570",
    className: "st2",
    d: "M13.3,11.1c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0.1-0.2,0.4-0.2,0.6-0.1c0,0,0,0,0,0 c0.1,0,0.1,0.1,0,0.2s-0.1,0.1-0.2,0c0,0-0.1,0-0.1,0C13.4,11,13.4,11,13.3,11.1C13.4,11.1,13.3,11.1,13.3,11.1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22571",
    className: "st2",
    d: "M12.3,9.8c3.9,0.1,3.1-4.5,6.1-4.4c0.1-0.2,0.1-0.4,0-0.6c-1.7-0.8-3.7-0.5-5,0.8 C12.2,6.7,11.8,8.4,12.3,9.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.1,11.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.3-0.2-0.3-0.4c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0.1 c0,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.1,0c0.1,0,0.2-0.2,0.1-0.3L18,9.6c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0.1l0.2,0.8 c0.1,0.4-0.1,0.7-0.4,0.8C18.2,11.2,18.1,11.2,18.1,11.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 16.4,
    cy: 9.7,
    r: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 19.1,
    cy: 8.9,
    r: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.1,12.3c-0.3,0-0.6-0.1-0.8-0.3c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3,0c0.2,0.2,0.5,0.3,0.8,0.2 c0.3-0.1,0.6-0.3,0.6-0.7c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.5-0.4,0.9-0.9,1C18.3,12.2,18.2,12.3,18.1,12.3z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulationsIcon);
export default __webpack_public_path__ + "static/media/simulations-icon.88bb72b5c5f70a8a9255d6939e85a305.svg";
export { ForwardRef as ReactComponent };